module.exports = __webpack_public_path__ + "img/buy_default.4fed684a.png";